var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{staticClass:"logoMP",attrs:{"to":"/"}},[_vm._v("MOVIE PREVIEW")]),(this.$route.path != '/')?_c('input',{staticClass:"btn btn-outline-success",attrs:{"type":"button","value":"Regresar"},on:{"click":_vm.goToBack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }